export const mobileSearchForm = () => {
  const trigger = document.querySelector('.h-top-mobile__search');
  const panel = document.querySelector('.h-top-mobile [data-search-panel]');
  const input = document.querySelector('.h-top-mobile [data-search-input]');
  const root = document.querySelector('.h-top-mobile [data-search-form]');
  const rowTop = document.querySelector('.h-top-mobile__row--top');

  if (!trigger || !panel || !root || !rowTop) return;

  const ACTIVE_CLASS = 'h-top-mobile__row--search-active';

  const close = () => {
    trigger.setAttribute('aria-expanded', 'false');
    panel.hidden = true;
    rowTop.classList.remove(ACTIVE_CLASS);
    root.classList.remove('search-form--active');
    root.parentElement.classList.remove('h-top-mobile__row--visible');
  };

  const open = () => {
    trigger.setAttribute('aria-expanded', 'true');
    panel.hidden = false;
    rowTop.classList.add(ACTIVE_CLASS);
    root.classList.add('search-form--active');
    root.parentElement.classList.add('h-top-mobile__row--visible');

    if (input) {
      requestAnimationFrame(() => input.focus());
    }
  };

  const toggle = () => {
    const isOpen = trigger.getAttribute('aria-expanded') === 'true';
    isOpen ? close() : open();
  };

  // start: zamknięty
  close();

  trigger.addEventListener('click', (e) => {
    e.preventDefault();
    toggle();
  });

  // klik poza panelem + poza triggerem -> zamknij
  document.addEventListener('click', (e) => {
    const clickedTrigger = e.target.closest('.h-top-mobile__search');
    const clickedInsidePanel = e.target.closest('[data-search-panel]');

    if (!clickedTrigger && !clickedInsidePanel) close();
  });

  // ESC -> zamknij
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') close();
  });
};